module.exports = __webpack_public_path__ + "img/icon-gas-water-heater.7292f8d0.svg";